<template>
  <div>
    <h5 class="title-subpanel t-fb-label">{{ a11y.choose_experiences }}</h5>
    <div class="experiences--list">
      <!-- destinos template -->
    </div>
    <div v-if="!isCuba" class="menu-item view-all child-item">
      <a :href="a11y.all_url" class="link js-all-experiences-link-main-menu">
        {{ a11y.all }}
      </a>
    </div>
  </div>
</template>

<script>
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'

const componentName = 'MobileMenuExperiences'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
  },
  props: {
    a11y: Object,
  },
  data() {
    return {}
  },
  computed: {
    isCuba() {
      return document.documentElement.dataset.inMicrosite == 'ibercuba'
    },
  },
}
</script>
